// removed by extract-text-webpack-plugin
module.exports = {"container":"_2r8Z95EgWTa6-ccCQrYUbN"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Main/styles.css
// module id = 1624
// module chunks = 83